import {
  API_DELETE_GAS_REPORT,
  API_GET_GAS_REPORT_BY_DAY_REPORT_ID,
  API_GET_GAS_REPORT_BY_ID,
  API_UPDATE_GAS_REPORT,
} from 'common/constants/apis';
import UILogger from 'common/utils/logger';
import httpClient from './config';
import {
  IDayReportEntryUpdateResp,
  IDayReportSummaryResponse,
} from 'common/interfaces/iDayReports';
import {DEFAULT_RETRY_CONFIG} from 'common/constants';
import {AxiosRequestConfig} from 'axios';
import {IGasReport, IGasReportResponse} from 'common/interfaces/iGasReport';

export function postUpsertGasReport<T>(
  payload: IGasReport,
): Promise<IDayReportEntryUpdateResp<T> | undefined> {
  UILogger.info('Sending update gas report entry request', payload);
  let url = API_UPDATE_GAS_REPORT;

  return httpClient
    .post(url, payload, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then(res => {
      UILogger.log('UPDATE gas report response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log('Error upserting void entry:::', error.response.data);
      return error.response.data;
    });
}

export function postDeleteGasReort(
  id: number,
): Promise<IDayReportEntryUpdateResp<boolean> | undefined> {
  UILogger.info('Sending delete gas report request:id', id);
  let url = API_DELETE_GAS_REPORT;
  url = url.replace('{id}', id.toString());

  return httpClient
    .delete(url, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then(res => {
      UILogger.log('DELETE: delete gas report response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log('Error deleting gas report entry:::', error.response.data);
      return error.response.data;
    });
}

export function getGasReportByDayReportId(
  reportId: number,
): Promise<IGasReportResponse | undefined> {
  UILogger.info('Sending get day report entry request. reportId:', reportId);
  let url = API_GET_GAS_REPORT_BY_DAY_REPORT_ID;

  url = url?.replace('{dayReportId}', reportId.toString());
  UILogger.info('Sending gas day report. url:', url);
  return httpClient
    .get(url, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then(res => {
      UILogger.log('GET gas day report response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log(
        'Error in getting gas day report entry: ',
        error.response.data,
        'by id::',
        reportId,
      );
      return error.response.data;
    });
}

export const getGasReportById = async (
  id: number,
): Promise<IDayReportSummaryResponse> => {
  UILogger.info('Sending get day report entry request. id:', id);
  let url = API_GET_GAS_REPORT_BY_ID;

  url = url?.replace('{id}', id.toString());
  UILogger.info('Sending gas day report. url:', url);
  return httpClient
    .get(url, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then(res => {
      UILogger.log('GET gas day report response: ', res.data);
      return res.data;
    })
    .catch(error => {
      console.log(
        'Error in getting gas day report entry: ',
        error.response.data,
        'by id::',
        id,
      );
      return error.response.data;
    });
};
